<template>
    <div class="QualityTest" ref="Box">
        <div class="QualityTestHeader">
            <img src="../../assets/img/left.png" @click="$router.back()" />
            预防性维护实施
        </div>
        <div class="infoBox firstBox">
            <p class="title">设备信息</p>
            <div class="info">
                <div>
                    <img src="@/assets/img/Icon_1.png" />
                </div>
                <div>
                    <p class="ellipsis">资产名称： <span>{{data.EquName}}</span></p>
                    <p class="ellipsis">使用科室： <span>{{data.DepName}}</span></p>
                </div>
                <div>
                    <p class="ellipsis">规格型号： <span>{{data.OrderNo}}</span></p>
                    <p class="ellipsis">出厂日期： <span>{{data.KeepDate}}</span></p>
                </div>
                <div>
                    <p class="ellipsis">资产编号： <span>{{data.EquId}}</span></p>
                    <p class="ellipsis">启用日期： <span>{{data.QYRQ}}</span></p>
                </div>
            </div>
        </div>
        <div class="infoBox quality">
            <div class="tableTitle">
                <div>检测项目</div>
                <div>检测内容</div>
                <div>检测结果</div>
                <div>说明</div>
            </div>
            <div class="tableItems" v-for="item in list">
                <div class="tableItemsLeftBox">{{item.title}}</div>
                <div class="tableItemsRightBox">
                    <div v-for="itemList in item.list">
                        <div>{{itemList.ProName}}</div>
                        <div>
                            <div :class="itemList.ResultSuccess === itemList.DefalultResult ? 'action' : ''" @click="() => itemList.DefalultResult = itemList.ResultSuccess">{{itemList.ResultSuccess}}</div>

                            <div :class="itemList.ResultError === itemList.DefalultResult ? 'action' : ''" @click="() => itemList.DefalultResult = itemList.ResultError">{{itemList.ResultError}}</div>
                        </div>
                        <div>
                            <input type="text" placeholder="请输入" v-model="itemList.Explain" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="infoBox quality">
            <div class="tableItems" v-for="item in list2">
                <div class="tableItemsLeftBox">{{item.title}}</div>
                <div :class="'tableItemsRightBox2 ' + item.type">
                    <van-checkbox-group v-model="calibration" v-if="item.type === 'checkbox-group'">
                        <van-checkbox v-for="(itemList,index) in item.list" :key="index" :name="index" checked-color="#4fa69e">{{itemList}}</van-checkbox>
                    </van-checkbox-group>
                    <van-radio-group v-model="actuality" v-if="item.type === 'checkbox'">
                        <van-radio v-for="(itemList, index) in item.list" :key="index" :name="index" checked-color="#4fa69e">{{itemList}}</van-radio>
                    </van-radio-group>
                    <div class="input-group" v-if="item.type === 'input-group'">
                        <div v-for="itemList in item.list">
                            <p>{{itemList.text}}</p>
                            <input type="text" v-if="itemList.type !== 'calender'" placeholder="请输入" v-model="itemList.explain"
                                :disabled="itemList.disabled ? 'disabled' : false" />

                            <div class="calenderText" v-if="itemList.type === 'calender'" @click="(showCalendar = true,setData = itemList)">{{itemList.explain ? itemList.explain : "请输入"}}</div>
                            <van-calendar :round="false" v-if="itemList.type === 'calender'" v-model="showCalendar"
                                @confirm="onConfirm" />
                        </div>
                    </div>
                    <input v-if="item.type === 'input'" type="text" :placeholder="item.explain ? item.explain : '请输入'"
                        v-model="item.explain" />
                </div>
            </div>
        </div>
        <div class="imgBox">
            <ImgModule :deletable='!this.$route.params.ButtonExists' :disabled='this.$route.params.ButtonExists' upload
                :img="uploadImg" title="图片" @afterRead="afterRead(arguments[0])" @deleteImg="deleteImg(arguments[0])" />
        </div>
        <div v-if="!this.$route.params.ButtonExists" class="footer" @click="upload">提交</div>
    </div>
</template>

<script>
    import ImgModule from '../../components/imgModule/imgModule'
    import {
        CheckboxGroup,
        Checkbox,
        RadioGroup,
        Radio,
        Calendar
    } from 'vant'
    export default {
        name: 'QualityTest',
        data() {
            return {
                data: this.$route.params.item, //基础数据
                list: [], //模板内容  api获取
                list2: [ //预防性维护固定内容  '内部除尘','电路调整','润滑加油','参数调整','内部管路清洁','机内灰尘清洁','安全测试校准'
                    {
                        title: '维护校准',
                        list: ['内部除尘', '电路调整', '润滑加油', '内部管路清洁', '机内灰尘清洁', '参数调整', '安全测试校准'],
                        type: 'checkbox-group'
                    },
                    {
                        title: '仪器现状',
                        list: ['工作正常', '可以使用', '有故障需进一步维修', '不能使用'],
                        type: 'checkbox'
                    },
                    {
                        title: '机房环境',
                        list: [{
                            text: '机房温度',
                            explain: null
                        }, {
                            text: '机房温度',
                            explain: null
                        }, {
                            text: '供电电压',
                            explain: null
                        }, {
                            text: '重要事项',
                            explain: null
                        }, ],
                        type: 'input-group'
                    },
                    {
                        title: '预防维护评价',
                        explain: null,
                        type: 'input'
                    },
                    {
                        title: '改进措施',
                        explain: null,
                        type: 'input'
                    },
                    {
                        title: '操作者意见',
                        explain: null,
                        type: 'input'
                    },
                    {
                        title: '备注',
                        explain: null,
                        type: 'input'
                    },
                    {
                        title: '其它',
                        list: [{
                            text: '科主任签名',
                            explain: null
                        }, {
                            text: '执行人',
                            explain: 'taotao',
                            disabled: true
                        }, {
                            text: '时间',
                            explain: null,
                            type: 'calender'
                        }, {
                            text: '执行时间',
                            explain: null,
                            type: 'calender'
                        }, ],
                        type: 'input-group'
                    },
                ],
                calibration: [], //  维护校准选中内容
                actuality: 0, //  仪器现状选中内容
                uploadImg: [], //   图片
                showCalendar: false, //   显示日历
                setData: null, //   用于区分日历组件指向哪一个item
                HttpList: [], //模板原始数据（总的数据集）
            }
        },
        components: {
            ImgModule,
            [Calendar.name]: Calendar,
            [Checkbox.name]: Checkbox,
            [CheckboxGroup.name]: CheckboxGroup,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio
        },
        mounted() {
            this.loadDataDefault();
        },
        methods: {
            //  日历
            onConfirm(date) {
                const _Date =
                    `${date.getFullYear()}-${date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1}-${date.getDate() < 9 ? '0' + date.getDate() : date.getDate()}`
                this.setData.explain = _Date
                this.showCalendar = false
            },
            //  提交
            upload() {
                let JHDH = this.data.OrderNo;
                //组合模板
                let UpList = [];
                for (let i = 0; i < this.list.length; i++) {
                    const model = this.list[i];
                    for (let j = 0; j < model.list.length; j++) {
                        const FirstModel = model.list[j];
                        UpList.push({
                            SSDH: JHDH,
                            XMLX: FirstModel.TMPId.substring(0, FirstModel.TMPId.indexOf('-')),
                            XMBH: FirstModel.TMPId.substring(FirstModel.TMPId.indexOf('-') + 1),
                            JCJG: FirstModel.DefalultResult
                        });
                        UpList.push({
                            SSDH: JHDH,
                            XMLX: 'TP',
                            XMBH: FirstModel.TMPIdOtherOne.substring(FirstModel.TMPIdOtherOne.indexOf('-') + 1),
                            JCJG: FirstModel.Explain
                        });
                    }
                }
                for (let i = 0; i < 19; i++) {
                    if (i >= 0 && i <= 6) { //维护校准（复选框）   实际值应该去循环i+1
                        UpList.push({
                            SSDH: JHDH,
                            XMLX: 'TP',
                            XMBH: i + 1,
                            JCJG: this.calibration.findIndex(x => x === i) === -1 ? '0' : '1'
                        });
                    }
                    if (i > 6 && i <= 10) { //仪器现状（单选）   实际值应该去循环i+1
                        UpList.push({
                            SSDH: JHDH,
                            XMLX: 'TP',
                            XMBH: 'TP' + (i + 1),
                            JCJG: this.actuality === (i - 7) ? '1' : '0'
                        })
                    }
                    if (i > 10 && i <= 14) { //机房环境
                        UpList.push({
                            SSDH: JHDH,
                            XMLX: 'TP',
                            XMBH: i + 1,
                            JCJG: (this.list2[2].list)[i - 11].explain
                        })
                    }
                    if (i > 14 && i < 19) { //意见书
                        UpList.push({
                            SSDH: JHDH,
                            XMLX: 'TP',
                            XMBH: i + 1,
                            JCJG: this.list2[i - 12].explain
                        })
                    }
                }

                UpList.push({
                    SSDH: JHDH,
                    XMLX: 'TP',
                    XMBH: 20,
                    JCJG: '设备使用科室负责人已知晓本次维护保养及监测评价结论，了解改进措施。'
                });
                for (let i = 0; i < 4; i++) {
                    let data = this.list2[7].list[i];
                    UpList.push({
                        SSDH: JHDH,
                        XMLX: 'TP',
                        XMBH: 21 + i,
                        JCJG: data.explain
                    });
                }
                let data = {
                    OrderNo: this.data.OrderNo,
                    Store: this.$UserInfo.StoreCode,
                    DepNo: '',
                    EquNo: this.data.EquId,
                    UserCode: this.$UserInfo.UserId, //检测人
                    VerifyUserCode: this.$UserInfo.UserId, //审核人
                    TestingDate: this.$format(new Date(), 'YYYY-MM-DD'),
                    SSDH: '',
                    UpList: [],
                    ResultList: UpList,
                    base64Str1: 1 <= this.uploadImg.length ? this.uploadImg[0].content : '',
                    base64Str2: 2 <= this.uploadImg.length ? this.uploadImg[1].content : '',
                    base64Str3: 3 <= this.uploadImg.length ? this.uploadImg[2].content : '',
                    base64Str4: 4 <= this.uploadImg.length ? this.uploadImg[3].content : '',
                    base64Str5: 5 <= this.uploadImg.length ? this.uploadImg[4].content : '',
                    base64Str6: 6 <= this.uploadImg.length ? this.uploadImg[5].content : '',
                    base64Str7: 7 <= this.uploadImg.length ? this.uploadImg[6].content : '',
                    base64Str8: 8 <= this.uploadImg.length ? this.uploadImg[7].content : '',
                };
                this.$post('api/YF/UpTMPForH5', data,{timeout:100000}).then(result => {
                    if (result.Status) {
                        this.$Toast({
                            message:'提交成功!',
                            duration:1500,
                            onClose:()=>{
                                this.$router.back();
                            }
                        });
                    } else this.$Toast(result.Msg);
                })
            },
            loadDataDefault() {
                //console.log(this.data);
                this.$post('api/YF/BYTMPListForH5', {
                    Store: this.$UserInfo.StoreCode,
                    UserCode: this.$UserInfo.UserId,
                    EquId: this.data.EquId,
                    OrderNo: this.data.OrderNo,
                    SSDH:this.data.SSDH
                }).then(result => {
                    this.actuality = Number(result.SBZT);
                    this.HttpList = result;
                    for (let i = 0; i < 10; i++) {
                        result['BYTMPList' + (i + 1)][0] ? this.list.push({
                            title: result['BYTMPList' + (i + 1)][0].MainName,
                            list: result['BYTMPList' + (i + 1)]
                        }) : '';
                    }
                    for (let i = 0; i < 7; i++) {
                        if (result['TMP' + (i + 1)] === '1') {
                            this.calibration.push(i);
                        }
                        if (i < 4) {
                            (this.list2[2].list)[i].explain = result['TMP' + (10 + i + 2)];
                            this.list2[i + 3].explain = result['TMP' + (10 + i + 4)];
                        };
                    }
                    for(let i=0;i<4;i++){
                       this.list2[7].list[i].explain=result['TMP'+(21+i)];
                    }
                    //图片模板
                    if (result.URLList) {
                        for (let i = 0; i < result.URLList.length; i++) {
                            this.uploadImg.push({
                                random: this.$getRandomNumber(5),
                                DABH: result.URLList[i].DABH,
                                BGDH: result.URLList[i].BGDH,
                                url: result.URLList[i].RePath,
                                JHDH: result.URLList[i].JHDH,
                                DALJ: result.URLList[i].DALJ
                            });
                        }
                    }
                })
            },
            afterRead(obj) { //上传图片
                if (obj instanceof Array) {
                    let that = this;
                    obj.forEach(function(item, index) {
                        that.uploadImg.push(item);
                    })
                } else this.uploadImg.push(obj);
            },
            deleteImg(obj) {
                if (!obj.content) { //说明是上传上来的
                    this.$Dialog.confirm({
                        message: '确定删除?'
                    }).then(() => {
                        this.$get('api/YF/DeleteAccessory', {
                            JHDH: obj.JHDH,
                            DABH: obj.DABH,
                            BGDH: obj.BGDH,
                            DALJ: obj.DALJ
                        }).then(result => {
                            if (result.Status) {
                                this.$Toast('删除成功!');
                                this.uploadImg.splice(this.uploadImg.findIndex(x => x.random === obj.random),
                                    1);
                            } else this.$Toast('删除失败!');
                        })
                    }).catch(() => {})
                } else {
                    this.uploadImg.splice(this.uploadImg.findIndex(x => x.random === obj.random), 1);
                    this.$Bus.$emit('YSRKDelete', this.uploadImg);
                }
            }
        },
    }
</script>

<style scoped lang="scss">
    .QualityTest {
        /*transform: rotate(90deg);*/
        /*width: 100vh;*/
        /*min-height: 750px;*/
        background: #F0F4F7;
        /*transform-origin: left top;*/
        /*margin-left: 100%;*/
        padding-bottom: 20px;
        padding-top: 48px;
    }

    .QualityTestHeader {
        width: 100vw;
        height: 48px;
        text-align: center;
        line-height: 48px;
        position: fixed;
        font-size: 18px;
        color: #fff;
        background: $THEME-COLOR;
        top: 0;
        z-index: 10;

        img {
            width: 23px;
            position: absolute;
            left: 2px;
            top: 2px;
            padding: 10px
        }
    }

    .infoBox {
        width: 96%;
        margin: 10px auto;
        padding: 10px 20px;

        .title {
            font-size: 12px;
            margin-bottom: 7px;
        }
    }

    .info {
        display: flex;

        &>div {
            flex: 1;
            text-align: left;
            font-size: 12px;
            color: #999;

            &:first-child {
                flex: 0.35
            }

            p {
                margin-top: 5px;
                margin-bottom: 9px;
                width: 95%;
            }

            span {
                color: $TEXT-DARK-COLOR;
            }

            img {
                width: 50px;
                height: 60px;
                border-radius: 1px;
            }
        }
    }

    .quality {
        padding: 0;
    }

    .tableTitle {
        display: flex;
        height: 33px;
        line-height: 33px;
        border-bottom: 1px solid #e8e8e8;
        font-weight: bold;

        div {
            flex: 1;
            font-size: 12px;
            color: $TEXT-DARK-COLOR;

            &:first-child {
                text-indent: 34px;
            }

            &:nth-child(3) {
                text-align: center;
                text-indent: 10px;
            }

            &:last-child {
                text-indent: 30px;
            }
        }
    }

    .tableItems {
        display: flex;
        font-size: 12px;
        color: #333;
        font-weight: bold;

        .tableItemsLeftBox {
            width: 100px;
            border-right: 1px solid #e8e8e8;
            display: flex;
            align-items: center;
            justify-content: center;
            border-bottom: 1px solid #e8e8e8;
        }

        &:last-child .tableItemsLeftBox,
        &:last-child .tableItemsRightBox>div,
        &:last-child .tableItemsRightBox2 {
            border-bottom: none;
        }

        .tableItemsRightBox {
            flex: 1;

            &>div {
                display: flex;
                border-bottom: 1px solid #e8e8e8;

                &>div {
                    &:first-child {
                        width: 240px;
                        padding: 19px 21px 12px;
                        text-align: left;
                    }

                    &:nth-child(2) {
                        flex: 0.8;
                        align-items: center;
                        justify-content: center;
                        display: flex;

                        div {
                            width: 47px;
                            height: 25px;
                            background: #F3F3F3;
                            border-radius: 2px;
                            color: #858585;
                            font-size: 8px;
                            line-height: 25px;
                            text-align: center;
                            font-weight: 400;
                            margin-right: 14px;

                            &:last-child {
                                margin-right: 0;
                            }
                        }

                        .action {
                            background: $THEME-COLOR;
                            color: #fff;
                            border-color: rgba(0, 0, 0, 0);
                        }
                    }

                    &:last-child {
                        flex: 1;
                        display: flex;
                        justify-content: center;
                        align-items: center;

                        input {
                            width: 115px;
                            height: 25px;
                            background: #f3f3f3;
                            border-radius: 4px;
                            font-size: 10px;
                            font-weight: 400;
                            text-indent: 12px;

                            ::-webkit-input-placeholder {
                                color: #858585;
                            }
                        }
                    }
                }
            }
        }

        .tableItemsRightBox2 {
            flex: 1;
            padding: 10px;
            border-bottom: 1px solid #e8e8e8;

            &>input {
                width: 95%;
                border: 1px solid #e8e8e8;
                margin: auto;
                border-radius: 4px;
                height: 40px;
                background: #f3f3f3;
                font-size: 10px;
                text-indent: 10px;
                font-weight: 400;
            }
        }

        .checkbox-group {
            padding-bottom: 0;

            &>div {
                display: flex;
                flex-wrap: wrap;

                &>div {
                    margin-right: 25px;
                    margin-bottom: 10px;
                }
            }
        }

        .checkbox {
            &>div {
                display: flex;

                &>div {
                    margin-right: 20px;
                }
            }
        }

        .input-group {
            display: flex;

            &>div {
                flex: 1;
                text-align: center;

                input,
                .calenderText {
                    width: 80%;
                    text-align: center;
                    border: 1px solid #e8e8e8;
                    margin: auto;
                    margin-top: 10px;
                    border-radius: 4px;
                    height: 25px;
                    background: #f3f3f3;
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 25px;
                    padding: 0;

                    ::-webkit-input-placeholder {
                        color: #858585;
                    }

                    &:disabled {
                        background-color: #f3f3f3;
                        color: $TEXT-DARK-COLOR;
                        opacity: 1;
                    }
                }
            }
        }
    }

    .lastBox {
        padding: 0 10px;

        span {
            color: #F4F4F4 !important;
        }
    }

    .imgBox {
        width: 96%;
        margin: auto;
    }

    .footer {
        width: 96%;
        margin: auto;
        height: 40px;
        background: $THEME-COLOR;
        border-radius: 4px;
        color: #fff;
        font-size: 12px;
        line-height: 40px;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/page/qualityTest/qualityTest.vue